import { createActionGroup, props } from '@ngrx/store';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    'Set Data Mosaix Token': props<{ token: string | null }>(),
    'Set Current Tenant Id': props<{ tenantId: string | null }>(),
  }
});